import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { AppService } from '../../shared/services/app.service';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { TranslateService } from '../../services/translate.service';

@Component({
    selector: 'app-summary-engine',
    templateUrl: './summary-engine.component.html',
    styleUrls: ['./summary-engine.component.scss'],
    standalone: false
})
export class SummaryEngineComponent implements OnInit {
  @Input() _summaryData: any = {};
  // @Input() gridData: any;
  // multiple_summary: boolean = true; // Flag to check if multiple summary is enabled
  // @Output() summaryResponse: EventEmitter<any> = new EventEmitter();
  // printData: any = [];
  //hideSummaryButton: boolean = false;

  constructor(
    private baseService: BaseService,
    private rolePermissionService: RolePermissionService,
    private appService: AppService,
    private alerts: AlertsService,
    private loader: LoaderService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    // this._summaryData.gridData = this._summaryData.gridData || {};
    // this._summaryData.datasource = this._summaryData.datasource || {};
    // this._summaryData.blocks.forEach(block => {
    //   block.list = block.list.filter(elem => {
    //     elem.visible = elem.visible ?? true; // Default to true if undefined/null
    //     return elem.visible !== false; // Keep only if not false
    //   });
    // });
  }

  getSummaryInfo() {
    this.loader.showSpinner();
    // this.getSummary(this.gridData, this._summaryData.datasource);
  }

  // getSummary(gridData, datasource, callback = null) {
  //   if (datasource.args)
  //     gridData['args'] = this.baseService.buildDyanamicStr(datasource.args, '')
  //   gridData['query_id'] = datasource.query_id;
  //   if (gridData['projectionKeys']) { delete gridData['projectionKeys'] }
  //   if (datasource.hasOwnProperty('action_name'))
  //     if (this.rolePermissionService.checkAccessPermission(datasource.action_name, datasource.resource, datasource.application)) {
  //       gridData['filter'] += ",treatingDoctorId:" + this.appService.getCurrentUser().user_id
  //     }
  //   if (gridData.args != undefined && gridData.args.includes("noCount:1")) {
  //     //do nothing
  //   } else if (datasource.noCount == false) { }
  //   else if (gridData.args != undefined && !gridData.args.includes("noCount:1")) {
  //     gridData.args = gridData.args + ",noCount:1"
  //   }
  //   else {
  //     gridData.args = "noCount:1"
  //   }
  //   //this.applyArchivePoicy(gridData, true);
  //   let obj = {};
  //   // if (this._currentData.isDownload != undefined && this._currentData.isDownload) {
  //   //   obj = { catchError: true };
  //   //   delete this._currentData.isDownload;
  //   // }
  //   this.baseService.getData(gridData, "", datasource.resource, datasource.application, undefined, obj).subscribe(
  //     (data: any) => {
  //       if (data.errCode == -1) {
  //         this.alerts.error(data.message);
  //         if (callback)
  //           callback(false);
  //       }
  //       else if (data.errCode == 504) {
  //         if (callback)
  //           callback(false);
  //       }
  //       else if (data && data.resource && data.resource.length > 0) {
  //         if (datasource.dynamic_keys) {
  //           if (Array.isArray(data.resource[0][datasource.dynamic_keys])) {

  //           } else if (typeof data.resource[0][datasource.dynamic_keys] == 'object') {
  //             this._summaryData.blocks.forEach((block) => {
  //               block.list.forEach((elem) => {
  //                 elem['value'] = data.resource[0][datasource.dynamic_keys][elem.name]
  //               })
  //             })
  //           }
  //         } else if (datasource.type == "multiple_array") {
  //           this.multiple_summary = false
  //           this._summaryData.blocks.forEach((block) => {
  //             block.list.forEach((elem) => {
  //               if (data.resource && block.key && data.resource.findIndex(x => x.key_name == block.key) != -1) {
  //                 elem['value'] = data.resource[data.resource.findIndex(x => x.key_name == block.key)][datasource.key].find(x => x.key == elem.name).value;
  //               }
  //             })
  //           });
  //           this._summaryData.blocks.push(this.setDynamicSummary(data.resource));
  //         } else {
  //           this._summaryData.blocks.forEach((block) => {
  //             block.list.forEach((elem) => {
  //               if (data.resource[0][elem.name] != undefined) {
  //                 elem['value'] = data.resource[0][elem.name];
  //               }
  //             })
  //           });
  //         }
  //         console.log("summary data", this._summaryData);
  //       }
  //       this._summaryData.hideSummaryButton = true;
  //       this.setPrintData();
  //       this.loader.hideSpinner();
  //     }, (err) => { console.log(err) });
  // }

  // setPrintData() {
  //   this.changedSummaryData((data) => {
  //     this.summaryResponse.emit({ data: data });
  //   })
  // }

  // changedSummaryData(cb) {
  //   if (this._summaryData && this._summaryData.blocks && this._summaryData.blocks.length > 0) {
  //     this._summaryData.blocks.forEach((block) => {
  //       block.list.forEach((elem) => {
  //         if (elem.value != null && elem.value != undefined) {
  //           this.translate.translate(elem.heading).subscribe((translatedHeading) => {
  //             let data = {};
  //             if (translatedHeading) {
  //               data["value"] = elem.value;
  //               data["key"] = translatedHeading
  //             }
  //             this.printData.push(data);
  //           });
  //         }
  //       })
  //     });
  //     cb(this.printData);
  //   }
  // }

  // setDynamicSummary(data) {
  //   let dynamicBlock = {};
  //   if (this._summaryData && this._summaryData.dynamic_fields) {
  //     if (this._summaryData.dynamic_fields && this._summaryData.dynamic_fields.type == 'multiple_array') {
  //       let value = data.find(x => x[this._summaryData.dynamic_fields.heading] == this._summaryData.dynamic_fields.dynamic_key)
  //       dynamicBlock['heading'] = value[this._summaryData.dynamic_fields.heading]
  //       dynamicBlock['key'] = value[this._summaryData.dynamic_fields.key]
  //       dynamicBlock['list'] = value[this._summaryData.dynamic_fields.list].map(item => {
  //         return {
  //           heading: item.key,
  //           name: item.key,
  //           value: item.value,
  //           visible: true
  //         }
  //       });
  //     }
  //   }
  //   return dynamicBlock;
  // }

}
